import React from "react";
import { UNIT_SYSTEM_OPTIONS } from "../data/machiningMaterials";

const UnitSystemSelector = ({ value, onChange, label = "Units" }) => (
  <div className="form-group">
    <label>{label}</label>
    <select value={value} onChange={(event) => onChange(event.target.value)}>
      {Object.entries(UNIT_SYSTEM_OPTIONS).map(([key, optionLabel]) => (
        <option key={key} value={key}>
          {optionLabel}
        </option>
      ))}
    </select>
  </div>
);

export default UnitSystemSelector;
